import { useCallback, useEffect, useState, type RefObject } from "react";

export function FullscreenToggle({
  targetRef,
}: {
  readonly targetRef: RefObject<HTMLElement | null>;
}) {
  const [isSupported, setIsSupported] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    setIsSupported(document.fullscreenEnabled === true);
    const onChange = () => {
      setIsFullscreen(document.fullscreenElement !== null);
    };
    document.addEventListener("fullscreenchange", onChange);
    return () => document.removeEventListener("fullscreenchange", onChange);
  }, []);

  const toggle = useCallback(() => {
    if (document.fullscreenElement !== null) {
      void document.exitFullscreen().catch(() => undefined);
      return;
    }
    void targetRef.current?.requestFullscreen().catch(() => undefined);
  }, [targetRef]);

  if (!isSupported) {
    return null;
  }

  return (
    <button
      aria-pressed={isFullscreen}
      className="fullscreen-toggle"
      type="button"
      onClick={toggle}
    >
      <span aria-hidden="true">{isFullscreen ? "⤡" : "⤢"}</span>
      {isFullscreen ? "Exit full screen" : "Full screen"}
    </button>
  );
}
